import {ProcessI, TaskStateI} from "./process.interface";
import {PermissionsI, PermissionsObjectI} from "./permissions.interface";
import {ActionButton, ProcessResultDataI} from "./process-result.interface";
import {environment} from "../../../environments/environment";

export enum TaskResultTab{
  "detail"="detail",
  "activities"="activities"
}

export enum TaskActionType{
  "approve"="approve",
  "skip"="skip",
  "cancel"="cancel"
}

export enum TaskStatus {
  empty = "empty",
  draft = "draft",
  complete = "complete",
  skip="skip",
  mixed="mixed"
}

export interface TaskActionsI{
  "icon": string;
  "label": string;
  "message": string;
  "status": TaskActionType;
}

export enum TaskType {
  "GROUP"="GROUP",
  "TASK"="TASK",
}

export enum ActivityType {
  "FORM"="FORM",
  "ACTIVITIES"="ACTIVITIES",
  "CALENDAR"="CALENDAR",
  "CALENDAR_BOOKING"="CALENDAR_BOOKING",
  "DAM_SHARED_FOLDER" = "DAM_SHARED_FOLDER",
  "CUSTOM_FORM"="CUSTOM_FORM",
  "COST_MANAGER"="COST_MANAGER",
  "PHI_VIEWER"="PHI_VIEWER",
  "DAM_V1"="DAM_V1",
  "REDIRECTOR"="REDIRECTOR",
  "IFRAME"="IFRAME",
  "SERVICES_PREVIEW"="SERVICES_PREVIEW",
  "SERVICES_EXECUTIONS"="SERVICES_EXECUTIONS",
  "SERVICES_WOOCOMMERCE"="SERVICES_WOOCOMMERCE"
}

export interface RedirectI {
  url: string;
  message?: string;
  image?: string;
  target?: string;
  button?: string;
  icon?: string;
}

export interface ActivityI {
  "id": string;
  "label": string;
  "type": ActivityType;
  formId?: string;
  formNotes?: boolean;
  page?: string;
  versionId?:string;
  api?: string;
  metadata: any;
  websocketServer?: string;
  websocketChannel?: string;
  submitAction?: string;
  saveAction?: string;
  qrForm?: boolean;
  qrLabel?: string;
  qrFormUrl?: string;
  qrShowUrl?: boolean;
  damV2Url?: string;
  damV3Url?: string;
  damModulePk?: string;
  damModuleSk?: string;
  damHeaders?: {
      "label": string,
      "key": string,
      "type": string
    }[];
  damOptionTags?: string[];
  damLang?: string;
  damMode?: 'write' | 'read' | 'view';
  damModeView?: string;
  damShowSelectedView?: boolean;
  damMainTag?: string;
  damOptionSearch?: any[];
  redirect?: { [kay:string]: RedirectI };
  iframe?: { [kay:string]: string };
  calendarRoot?: boolean;
  calendarEdit?: boolean;
  calendarStatus?: string;
  costManagerEdit?: boolean;
  eventId?: string;
  previewTemplate?: string;
  previewBorder?: string;
  previewBackground?: string;
  onDataTaskStatus?: string;
  onDataProcessStatus?: string;
  apiV2?: string;
}

export interface TaskI {
  "id": string;
  "resultId": string;
  "actions": TaskActionsI[],
  "label": string;
  "type": TaskType;
  "children": TaskI[];
  "parentId": string;
  "status": TaskStateI,
  "updated_at": string;
  "draftDate": string;
  "updated_by": {
    "username": string;
    "full_name": string;
    "profile": any;
    "email": string;
  };
  "dispatch": string;
  "modalHeaderData": ProcessResultDataI;
  "bookmarked": boolean;
  "metadata": any[];
  "percentComplete": number;
  "activities": ActivityI[];
  "allowedStatus": TaskStatus[];
  allowedFullStatus?: TaskStateI[];
  "allowManualStatusChanges": boolean;
  "acl": {
    objects: PermissionsObjectI[];
    list: string[];
    read: string[];
    write: string[];
    delete: string[];
  };
  "user_permissions": PermissionsI;
  "picture": string;
  "color": string;
  process_status?: any;
  selected?: boolean;
  level?: number;
  total?: {
    color: string,
    icon: string,
    key: string,
    label: string,
    total: number
  }[] ;
  "action_buttons": ActionButton[];
  editable?: {
    value: boolean;
    message: string;
  }
}

export interface TaskPaginatorI {
  "count": number;
  "next": number | null;
  "page": number;
  "previous": number | null;
}

export interface TaskResponseI{
  "count": number;
  "page": number;
  "next": number | null;
  "previous": number | null;
  "results": TaskI[];
}

export enum DetailTabs {
  "info"="info",
  "security"="security"
}

export interface TaskPermissionsObjectI {
  object: PermissionsObjectI;
  permissions: PermissionsI;
}

export interface DamV1Config {
  url: string;
  urlAccessControl: string;
  idsModule: {
    pk: string;
    sk: string;
  };
  secretbKey: string;
  headersTable: {
      label: string;
      key: string;
      type: string;
    }[];
  tagsSearch: string | string[]; // El tag por el cual se van a buscar lo elementos que componen la lista
  owner: string; // email del usuario autenticado
  optionsTags: string[]; // Corresponde a los tags type dentro del headersTable
  tagsFiles: string[]; // tags que se le agregan a los files cuando se suban
  showSelectModeView: boolean;
  mainTag: string;
  optionSearch: any[];
}
